<script setup>
import Icon from '@/components/ds/Icon.vue';

defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true },
  icon: { type: String, required: true },
  open: { type: Boolean, default: true },
});

defineEmits(['toggle']);
</script>

<template>
  <details
    :open="open"
    class="landing-group"
    @toggle="$emit('toggle', $event)"
  >
    <summary class="landing-group__summary">
      <span class="landing-group__icon"><Icon
        :name="icon"
        :size="20"
      /></span>
      <span class="landing-group__copy">
        <span class="landing-group__title">{{ title }}</span>
        <span class="landing-group__description">{{ description }}</span>
      </span>
      <span class="landing-group__chevron"><Icon
        name="chevDown"
        :size="20"
      /></span>
    </summary>
    <div class="landing-group__content">
      <slot />
    </div>
  </details>
</template>

<style scoped>
.landing-group {
  min-width: 0;
  border: var(--bw-thin) solid var(--border-default);
  border-radius: var(--radius-xl);
  background: var(--bg-subtle);
}

.landing-group__summary {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-5);
  border-radius: var(--radius-xl);
  cursor: pointer;
  list-style: none;
}

.landing-group__summary::-webkit-details-marker {
  display: none;
}

.landing-group__summary:hover {
  background: var(--bg-hover);
}

.landing-group__summary:focus-visible {
  outline: var(--bw-thick) solid var(--accent-border);
  outline-offset: var(--space-1);
}

.landing-group__icon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: var(--control-lg);
  height: var(--control-lg);
  border: var(--bw-thin) solid var(--border-default);
  border-radius: var(--radius-lg);
  background: var(--bg-canvas);
  color: var(--accent-fg-on-soft);
}

.landing-group__copy {
  display: grid;
  gap: var(--space-1);
  min-width: 0;
}

.landing-group__title {
  font-size: var(--text-lg);
  font-weight: var(--fw-semibold);
  color: var(--fg-primary);
}

.landing-group__description {
  font-size: var(--text-sm);
  color: var(--fg-secondary);
}

.landing-group__chevron {
  display: flex;
  flex-shrink: 0;
  margin-left: auto;
  color: var(--fg-secondary);
}

.landing-group[open] > .landing-group__summary .landing-group__chevron {
  transform: rotate(180deg);
}

.landing-group__content {
  padding: 0 var(--space-5) var(--space-5);
}

@media (width <= 639px) {
  .landing-group__summary {
    padding: var(--space-4);
  }

  .landing-group__content {
    padding: 0 var(--space-3) var(--space-3);
  }
}
</style>
